export * from "@/ui/components/primitives/AspectRatio/AspectRatio";
export * from "@/ui/components/primitives/AspectRatio/AspectRatio.config";
